function toProperCase(str: string) {
  if (!str) {
    return str;
  }

  return str[0].toUpperCase() + str.slice(1);
}

function toProperCaseAllWords(str: string) {
  if (!str) {
    return str;
  }
  return str.split(' ').map(toProperCase).join(' ');
}

export { toProperCase, toProperCaseAllWords };
